"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ENV_SHAPE_PROP_TYPE", {
  enumerable: true,
  get: function get() {
    return _constants.ENV_SHAPE_PROP_TYPE;
  }
});
Object.defineProperty(exports, "REQUEST_SHAPE_PROP_TYPE", {
  enumerable: true,
  get: function get() {
    return _constants.REQUEST_SHAPE_PROP_TYPE;
  }
});
Object.defineProperty(exports, "USER_SHAPE_PROP_TYPE", {
  enumerable: true,
  get: function get() {
    return _constants.USER_SHAPE_PROP_TYPE;
  }
});
Object.defineProperty(exports, "FOOTER_LINKS_SHAPE_PROP_TYPE", {
  enumerable: true,
  get: function get() {
    return _constants.FOOTER_LINKS_SHAPE_PROP_TYPE;
  }
});
Object.defineProperty(exports, "ENV_PROP_FIXTURE", {
  enumerable: true,
  get: function get() {
    return _fixtures.ENV_PROP_FIXTURE;
  }
});
Object.defineProperty(exports, "USER_PROP_FIXTURE", {
  enumerable: true,
  get: function get() {
    return _fixtures.USER_PROP_FIXTURE;
  }
});
Object.defineProperty(exports, "FOOTER_LINKS_PROP_FIXTURE", {
  enumerable: true,
  get: function get() {
    return _fixtures.FOOTER_LINKS_PROP_FIXTURE;
  }
});
exports.enhance = exports.SiteStructure = void 0;

var _SiteStructure = _interopRequireDefault(require("./SiteStructure"));

var _utils = require("./utils");

var _constants = require("./constants");

var _fixtures = require("./fixtures");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SiteStructure = (0, _utils.enhance)(_SiteStructure.default);
exports.SiteStructure = SiteStructure;
var enhance = _utils.enhance;
exports.enhance = enhance;
//# sourceMappingURL=index.js.map